type Gift = {
    ID: number;
    Name?: string;
    DisplayName?: string;
    Order?: number;
    Amount?: number;
};

export const GiftItem = (props: { info: Gift }) => {
    return (
        <img
            src={`${process.env.PUBLIC_URL}/resource/assets/image/gift/gift_${props.info.ID}.png`}
        />
    );
};
